export enum FontSizes {
  normal = "1em",
  small = "0.8em",
  large = "1.2em",
  huge = "1.5em"
}



// WEBPACK FOOTER //
// ./src/lib/styles/Typography.tsx